import { isServer } from '.';

export interface InMemoryStorage {
  getItem(key: string): string | null,

  setItem(key: string, value: Record<string, any>): void,

  removeItem(key: string): void,

  clear(): void,

  key(index: number): void,

  get length(): number,
}

class ServerInMemoryStorage implements InMemoryStorage {
  getItem(): string | null {
    return null;
  }

  setItem(): void {}

  removeItem(): void {}

  clear(): void {}

  key(): void {}

  get length(): number {
    return 0;
  }
}

class ClientInMemoryStorage implements InMemoryStorage {
  storage: Record<string, any>;

  constructor() {
    this.storage = {};
  }

  getItem(key: string) {
    const item = this.storage[key];
    if (item) {
      return item;
    }
    return null;
  }

  setItem(key: string, value: Record<string, any>) {
    this.storage[key] = value;
  }

  removeItem(key: string) {
    delete this.storage[key];
  }

  clear() {
    this.storage = {};
  }

  key(index: number) {
    const keys = Object.keys(this.storage);
    return keys[index] || null;
  }

  get length() {
    return Object.keys(this.storage).length;
  }
}

export default isServer() ? ServerInMemoryStorage : ClientInMemoryStorage;
